import styled from 'styled-components';
import { toRem } from '../utils/pixelUtils';
import { Typography } from '@interstate/components/Typography';

export const FsSyncFailureTitle = styled(Typography)`
    margin-bottom: ${toRem(5)} !important;
`;

export const FsSyncFailureBannerContainer = styled.div`
    margin-bottom: ${toRem(16)};
    margin-top: ${toRem(16)};
`;

export const FsSyncFailureIndent = styled.div`
    margin-left: ${toRem(16)};
`;

export const FsSyncFailureGroup = styled(FsSyncFailureIndent)`
    margin-top: ${toRem(16)};
`;

export const FsSyncFailureSection = styled.div`
    margin-top: ${toRem(16)};
`;

export const FsSyncFailureAcknowledgement = styled.div`
    margin-top: ${toRem(16)};
`;
